module.exports = __webpack_public_path__ + "img/logo3.913e87ec.png";